export default __webpack_public_path__ + "static/favicon-debdd504343530687ac4e83c71f63f22.ico";